<template>
  <svg :viewBox="`0 0 ${W} ${H}`" :style="{height: H + 'px', direction: 'ltr'}">
    <g v-for="k in 5" :key="'g' + k">
      <line :x1="mS" :y1="Y(max * (k - 1) / 4)" :x2="W - 10" :y2="Y(max * (k - 1) / 4)" stroke="var(--sd-line-2)" stroke-width="1" />
      <text :x="mS - 6" :y="Y(max * (k - 1) / 4) + 3.5" class="ax" text-anchor="end">{{ compact(max * (k - 1) / 4) }}</text>
    </g>
    <g v-for="(y, i) in years" :key="y">
      <template v-for="(s, si) in series">
        <rect v-if="s.v[y] != null" :key="s.name + y" v-tip="`<b>${esc(s.name)}</b> · ${y}<br>${fmt(s.v[y])}`" :x="x0(i) + si * (bw + 3)" :y="Y(s.v[y])" :width="bw" :height="Math.max(0, H - mB - Y(s.v[y]))"
          rx="4" :fill="s.color" :opacity="muted(y) ? .3 : 1" />
        <text v-if="s.v[y] != null && !muted(y) && series.length <= 2" :key="'l' + s.name + y" :x="x0(i) + si * (bw + 3) + bw / 2" :y="Y(s.v[y]) - 5" text-anchor="middle" class="ax" font-size="10">{{ compact(s.v[y]) }}</text>
      </template>
      <text :x="mS + i * gw + gw / 2" :y="H - 10" text-anchor="middle" class="ax">{{ y }}</text>
    </g>
  </svg>
</template>
<script>
/* Grouped count bars per year. series: [{ name, color, v: { [year]: count } }] */
import { compact, fmt, esc } from '../../lib/format.js'
export default {
  name: 'SdBarsChart',
  props: { series: { type: Array, default: () => [] }, years: { type: Array, default: () => [] }, hl: { type: Array, default: null }, height: { type: Number, default: 210 } },
  data: () => ({ W: 520, mS: 50, mT: 18, mB: 30 }),
  computed: {
    H() { return this.height },
    max() { let m = 0; this.series.forEach((s) => this.years.forEach((y) => { if (s.v[y] != null) m = Math.max(m, s.v[y]) })); return m || 1 },
    gw() { return (this.W - this.mS - 16) / Math.max(1, this.years.length) },
    bw() { return Math.max(6, Math.min(26, (this.gw - 12) / Math.max(1, this.series.length))) },
  },
  methods: {
    compact, fmt, esc,
    Y(v) { return this.mT + (1 - v / this.max) * (this.H - this.mT - this.mB) },
    x0(i) { return this.mS + i * this.gw + (this.gw - this.bw * this.series.length - 3 * (this.series.length - 1)) / 2 },
    muted(y) { return this.hl && !this.hl.includes(+y) },
  },
}
</script>
